import $ from 'jquery';

export default () => {
    //console.log("calendario");

    function downloadIcs(button) {
        //title
        var eventTitle = $(button).closest('.singolo-evento').find('.title').text().trim();
        
        //text
        var eventText = $(button).closest('.singolo-evento').find('.text').text().trim();
        
        //data
        var data = $(button).closest('.singolo-evento').find('.data').attr("data-eventdate").replaceAll("-", "");
        var eventStart = data + "T000000";
        var eventEnd = "T000000";

        var filename = eventTitle.replace(/[^a-z0-9]/gi, '_').toLowerCase() + '.ics';

        var obj = "BEGIN:VCALENDAR\n" +
            "VERSION:2.0\n" +
            "CALSCALE:GREGORIAN\n" +
            "BEGIN:VEVENT\n" +
            "SUMMARY:" + eventTitle + "\n" +
            "DTSTART;TZID=Italia/Roma:" + eventStart + "\n" +
            "DTEND;TZIDItalia/Roma:" + eventEnd + "\n" +
            "LOCATION:\n" +
            "DESCRIPTION:" + eventText + "\n" +
            "END:VEVENT\n" +
            "END:VCALENDAR\n";

        
        var version = detectIE();
        if (version === false) {
            // NORMAL BROWSER
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(obj));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        } else if (version >= 12) {
            // EDGE
            window.navigator.msSaveBlob(
                new Blob([eventDescription],
                    { type: "text/calendar;charset=utf-8;" }),
                filename
            );
        } else {
            // IE
            window.navigator.msSaveBlob(
                new Blob([eventDescription],
                    { type: "text/calendar;charset=utf-8;" }),
                filename
            );
        }


        function detectIE() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }
    }

    $(".singolo-evento .aggiungi-calendario").on('click', function () {
        //console.log("aggiungi-calendario");
        downloadIcs(this);
    });

    $(".singolo-evento .condividi").on('click', function () {
        //console.log("condividi");
    });

    $('#shareModal').on('show.bs.modal', function (e) {

        //get data-id attribute of the clicked element
        var title = $(e.relatedTarget).data('bs-title');
        //console.log('title: ' + title);
    });
};



// WEBPACK FOOTER //
// ../views/componente-calendario/calendario.js